module.exports = __webpack_public_path__ + "img/OldSchoolTrunk.52c42d0a.png";